
import Home from "./paginas/Home";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  //bloquear código fonte
  window.document.oncontextmenu = window.document.body.oncontextmenu = function () { return false; }


  return (

    <>
      <Home />
      <ToastContainer autoClose={10000} />
    </>


  );
}

export default App;
